// extracted by mini-css-extract-plugin
export var footer = "_s2-0";
export var inherit = "_s2-1";
export var input = "_s2-2";
export var modalContent = "_s2-3";
export var quillEditor = "_s2-4";
export var subtitle = "_s2-5";